export class KpiModel {
  constructor(kpiType, key, kpi, increment) {
    this.kpiType = kpiType;
    this.key = key;
    this.kpi = kpi;
    this.increment = increment;
  }
}
